export default __webpack_public_path__ + "static/highlight-bastarda-efe8dc5ec47ddadd689a15eb06e98cc2.png";